<template>
    <span  v-if="routeId">
        <b-link :to="{ name: routeName, params: { id: routeId } }" :class="{ prependWithN: 'text-nowrap' }" v-if="!restricted">
            <span v-if="prependWithN">№</span>
            <span>{{ title }}</span>
        </b-link>
        <span v-else>{{ title }}</span>
    </span>
    <span v-else>&mdash;</span>
</template>

<script>
    export default {
        name: "LinkCell",
        props: {
            title: { },
            routeName: { type: String },
            routeId: { type: Number },
            prependWithN: { type: Boolean },
            restricted: { type: Boolean, default: false },
        }
    }
</script>

<style scoped>

</style>